(function(){
  'use strict';

  function start(){
    var checkbox = document.getElementById('mdiPushIQToggle');
    var status = document.getElementById('mdiPushIQStatus');
    if (!checkbox || !status) return;

    var bridge = null;
    var attempts = 0;
    var maximumAttempts = 20;
    var awaitingState = false;
    var responseTimer = null;

    function locate(){
      try {
        return window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.driveIQPushIQ || null;
      } catch(e) {
        return null;
      }
    }

    function diagnostic(){
      var hasWebKit = !!window.webkit;
      var hasHandlers = !!(window.webkit && window.webkit.messageHandlers);
      var hasPushIQ = !!locate();
      var frame = 'unknown';
      try { frame = window.top === window ? 'main' : 'embedded'; }
      catch(e) { frame = 'restricted'; }
      return 'Bridge check: WebKit=' + hasWebKit +
        ' | Handlers=' + hasHandlers +
        ' | PushIQ=' + hasPushIQ +
        ' | Frame=' + frame;
    }

    function request(action, enabled){
      bridge = locate();
      if (!bridge) return false;
      var message = {action: action};
      if (typeof enabled === 'boolean') message.enabled = enabled;
      try {
        bridge.postMessage(message);
        return true;
      } catch(e) {
        checkbox.disabled = true;
        status.textContent = 'Native request failed. ' + diagnostic();
        return false;
      }
    }

    window.addEventListener('driveiq:pushiq-state', function(event){
      var data = event.detail || {};
      if (data.available !== true) return;
      awaitingState = false;
      if (responseTimer) clearTimeout(responseTimer);
      checkbox.checked = !!data.enabled;
      checkbox.disabled = false;
      status.textContent = data.enabled
        ? (data.authorized
          ? 'Push IQ reminders enabled.'
          : 'Preference saved. Check notifications in iPhone Settings.')
        : 'Push IQ reminders are off.';
    });

    function getState(){
      if (!request('getState')) return false;
      awaitingState = true;
      if (responseTimer) clearTimeout(responseTimer);
      responseTimer = setTimeout(function(){
        if (awaitingState) {
          checkbox.disabled = true;
          status.textContent = 'Native bridge found, but no state response. ' + diagnostic();
        }
      }, 3000);
      return true;
    }

    checkbox.addEventListener('change', function(){
      checkbox.disabled = true;
      status.textContent = 'Updating your preference…';
      if (request('setEnabled', checkbox.checked)) {
        // The native side must send back the authoritative state.
        awaitingState = true;
        if (responseTimer) clearTimeout(responseTimer);
        responseTimer = setTimeout(function(){
          if (awaitingState) {
            checkbox.disabled = true;
            status.textContent = 'No confirmation from the iPhone app. ' + diagnostic();
          }
        }, 5000);
      }
    });

    function probe(){
      bridge = locate();
      if (bridge) {
        checkbox.disabled = true;
        status.textContent = 'Checking Drive IQ notification preferences…';
        getState();
        return;
      }
      attempts += 1;
      if (attempts < maximumAttempts) {
        checkbox.disabled = true;
        status.textContent = 'Connecting to the Drive IQ app…';
        setTimeout(probe, 250);
      } else {
        checkbox.disabled = true;
        status.textContent = diagnostic();
      }
    }

    window.addEventListener('pageshow', function(){
      if (locate()) getState();
    });
    document.addEventListener('visibilitychange', function(){
      if (!document.hidden && locate()) getState();
    });

    checkbox.disabled = true;
    probe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once:true});
  } else {
    start();
  }
})();
